<template>
  <div class="japan-power-week-2025">
    <!-- Hero Section -->
    <section class="hero-section ct-dark-section">
      <div class="container py-5">
        <div class="row align-items-center">
          <div class="col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
            <div class="badge ct-badge mb-3">
              <i class="fas fa-calendar-alt me-2"></i>21st October 2025 • Tokyo
            </div>
            <h1 class="display-4 fw-bold mb-3">
              Transform Your Japan Power Trading
            </h1>
            <p class="lead mb-4">
              From chat to cleared trade in minutes—CT Grid delivers instant
              access, seamless STP, and full market visibility for Japan’s power
              traders.
            </p>
            <div class="hero-stats">
              <div class="stat-item" @click="scrollToForm">
                <i class="fas fa-bolt"></i>
                <div>
                  <h3>Chat to Screen</h3>
                  <p>
                    Aggregate LSEG Messenger & WhatsApp market orders in
                    real-time.
                  </p>
                </div>
              </div>
              <div class="stat-item" @click="scrollToForm">
                <i class="fas fa-chart-line"></i>
                <div>
                  <h3>J-NET STP</h3>
                  <p>Process TOCOM block trades in minutes.</p>
                </div>
              </div>
              <div class="stat-item" @click="scrollToForm">
                <i class="fas fa-chart-line"></i>
                <div>
                  <h3>JEPX Screen</h3>
                  <p>
                    Access JEPX Day Ahead and Intra-day markets via CT Grid.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="hero-image-container">
              <img
                src="@/assets/japan_map.svg"
                alt="Japan Power Market"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <!-- <section class="features-section py-5">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="fw-bold">Why CT Grid for Japan Power?</h2>
          <p class="lead text-muted">
            Purpose-built tools for the Japanese electricity market
          </p>
        </div>

         <div class="row g-4">
          <div class="col-md-6 col-lg-3">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="fas fa-bolt"></i>
              </div>
              <h4>Real-Time Market Data</h4>
              <p>
                Live pricing and trades across JEPX spot, intraday, and all 10
                regional markets
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="fas fa-map-marked-alt"></i>
              </div>
              <h4>Regional Coverage</h4>
              <p>
                Complete visibility into Hokkaido, Tohoku, Tokyo, Chubu,
                Hokuriku, Kansai, Chugoku, Shikoku, Kyushu, and Okinawa
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="fas fa-file-excel"></i>
              </div>
              <h4>Excel Integration</h4>
              <p>
                Seamless Excel add-in for familiar workflows with live data
                feeds
              </p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="feature-card">
              <div class="feature-icon">
                <i class="fas fa-mobile-alt"></i>
              </div>
              <h4>Mobile Access</h4>
              <p>Stay connected on the go with iOS and Android apps</p>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Form Section -->
    <section ref="formSection" class="form-section ct-dark-section py-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="form-header text-center mb-4">
              <h2 class="fw-bold mb-3">Tell us about your interests</h2>
              <!-- <p class="lead">
                Let us know what you're interested in and we'll arrange a
                personalized demo at our booth.
              </p> -->
            </div>
            <div class="card ct-card p-4">
              <JapanPowerWeek2025Form />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- About Section -->
    <!-- <section class="about-section py-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 mb-4 mb-lg-0">
            <h2 class="fw-bold mb-4">
              Trusted by Japan's Power Market Participants
            </h2>
            <p class="mb-3">
              CT Grid is the independent platform of choice for brokers and
              traders operating in Japan's rapidly evolving power markets.
            </p>
            <p class="mb-3">
              Our platform aggregates data from multiple sources, calculates
              real-time analytics, and distributes insights across your team—all
              while maintaining the highest standards of security and
              compliance.
            </p>
            <p class="mb-4">
              Join leading firms who trust CT Grid to power their Japan power
              trading operations.
            </p>
            <router-link to="/markets/japan-power" class="ct-btn-secondary">
              Explore Japan Power Features
              <i class="fas fa-arrow-right ms-2"></i>
            </router-link>
          </div>
          <div class="col-lg-6">
            <div class="stats-grid">
              <div class="stat-box">
                <i class="fas fa-users"></i>
                <h3>10/10</h3>
                <p>Regional Markets Covered</p>
              </div>
              <div class="stat-box">
                <i class="fas fa-building"></i>
                <h3>100+</h3>
                <p>Active Users in APAC</p>
              </div>
              <div class="stat-box">
                <i class="fas fa-globe-asia"></i>
                <h3>24/7</h3>
                <p>Real-Time Market Monitoring</p>
              </div>
              <div class="stat-box">
                <i class="fas fa-shield-alt"></i>
                <h3>Enterprise</h3>
                <p>Security & Compliance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import JapanPowerWeek2025Form from "@/components/campaigns/JapanPowerWeek2025Form.vue";

const formSection = ref(null);

const scrollToForm = () => {
  if (formSection.value) {
    formSection.value.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

onMounted(() => {
  document.title = "Japan Power Week 2025 | CT Grid";
});
</script>

<style scoped>
.japan-power-week-2025 {
  /* Let content determine natural height instead of forcing 100vh */
  margin-bottom: 2rem;
}

/* Hero Section */
.hero-section {
  background: linear-gradient(
    135deg,
    var(--ct-dark) 0%,
    var(--ct-dark-secondary) 100%
  );
  border-bottom: 2px solid var(--ct-orange);
}

.ct-badge {
  display: inline-block;
  background-color: rgba(253, 153, 0, 0.15);
  color: var(--ct-orange);
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.hero-stats {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border-left: 3px solid var(--ct-orange);
  cursor: pointer;
  transition: all 0.3s ease;
}

.stat-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
  transform: translateX(5px);
  border-left-width: 4px;
}

.stat-item i {
  font-size: 2rem;
  color: var(--ct-orange);
}

.stat-item h3 {
  font-size: 1.1rem;
  margin: 0;
  font-weight: 600;
}

.stat-item p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--ct-text-secondary);
}

.hero-image-container {
  padding: 2rem;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(253, 153, 0, 0.2);
  overflow: hidden;
}

.hero-image-container img {
  object-fit: cover;
  object-position: center top;
  height: 80%; /* Crop bottom 20% */
  width: 100%;
}

/* Features Section */
.features-section {
  background-color: var(--ct-dark-secondary);
}

.feature-card {
  background-color: var(--ct-dark);
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid var(--ct-dark-tertiary);
  height: 100%;
  transition: all 0.3s ease;
}

.feature-card:hover {
  border-color: var(--ct-orange);
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(253, 153, 0, 0.2);
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(
    135deg,
    var(--ct-orange) 0%,
    var(--ct-orange-dark) 100%
  );
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.feature-icon i {
  font-size: 1.8rem;
  color: #000;
}

.feature-card h4 {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.feature-card p {
  color: var(--ct-text-secondary);
  margin: 0;
  font-size: 0.95rem;
}

/* Form Section */
.form-section {
  background: linear-gradient(
    135deg,
    var(--ct-dark-secondary) 0%,
    var(--ct-dark) 100%
  );
  padding-bottom: 5rem !important; /* Ensure space before footer */
}

.form-header {
  color: var(--ct-text-primary);
}

/* About Section */
.about-section {
  background-color: var(--ct-dark);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.stat-box {
  background-color: var(--ct-dark-secondary);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid var(--ct-dark-tertiary);
  text-align: center;
  transition: all 0.3s ease;
}

.stat-box:hover {
  border-color: var(--ct-orange);
  transform: scale(1.05);
}

.stat-box i {
  font-size: 2.5rem;
  color: var(--ct-orange);
  margin-bottom: 1rem;
}

.stat-box h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.stat-box p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--ct-text-secondary);
}

/* Responsive */
@media (max-width: 991.98px) {
  .hero-stats {
    margin-top: 2rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .stat-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>
